import { SuppliersContext } from 'Context/SuppliersContext';
import {
  DoctorsSuppliersContext,
  IDoctorsSuppliersContext,
} from 'Context/SuppliersContext/DoctorsSuppliersContext';
import {
  ITherapySuppliersContext,
  TherapySuppliersContext,
} from 'Context/SuppliersContext/TherapySuppliersContext';
import { SUPPLIERS_ID } from 'Enum/suppliers';
import { useContext } from 'react';

type GenericSupplierContext =
  | ITherapySuppliersContext
  | IDoctorsSuppliersContext;

export const useSupplierContext = () => {
  const { suppliersId } = useContext(SuppliersContext);

  const getContext = () => {
    switch (suppliersId) {
      default:
      case SUPPLIERS_ID.mentalTherapy:
        return TherapySuppliersContext;
      case SUPPLIERS_ID.doctors:
        return DoctorsSuppliersContext;
    }
  };

  return useContext(getContext() as React.Context<GenericSupplierContext>);
};
